import { handleError } from 'services/ErrorService/ErrorService';
import {
  DescriptionBody,
  DescriptionCloseButton,
  DescriptionContainer,
  DescriptionHeader,
  DescriptionTitle,
  DescriptionDivider,
} from './DescriptionPopup.styles';

const DescriptionPopup = ({ title, body, closeHandler }) => {
  /**
   * Using a passed state handler instead of dispatching
   * state action to toggle visibility of a component.
   * Using null as it can act as boolean false and object "false".
   */
  const handleDescriptionClose = () => {
    try {
      if (closeHandler) {
        closeHandler(null);
      } else {
        const errorReason = 'Undefined or invalid close handler';
        const errorCause = { descriptionPopup: errorReason };
        throw new Error(errorReason, { cause: errorCause });
      }
    } catch (error) {
      // Show a generic message but log over to Sentry for the root cause
      handleError({ error, customFields: error.cause, showPopup: true });
    }
  };

  return (
    <DescriptionContainer>
      <DescriptionHeader>
        <DescriptionTitle>{title}</DescriptionTitle>
        <DescriptionCloseButton
          onClick={handleDescriptionClose}
          className="description-close-button"
          src="/images/new-designs/close-icon.svg"
          alt="close-icon"
        />
      </DescriptionHeader>
      <DescriptionDivider />
      <DescriptionBody>{body}</DescriptionBody>
    </DescriptionContainer>
  );
};

export default DescriptionPopup;
